<template>
  <v-container
    fluid
  >
    <v-row align="center">
      <v-col
        class="pb-0 pt-0"
        cols="auto"
      >
        <v-tabs
          v-model="selectedTab"
        >
          <v-tab>
            ACTIVE
          </v-tab>
          <v-tab>
            ARCHIVED
          </v-tab>
        </v-tabs>
      </v-col>
      <v-spacer />
      <v-col
        v-if="roles.includes(userRoleIdAdmin) || roles.includes(userRoleIdAssociate) || roles.includes(userRoleIdRequester)"
        class="text-end pb-0"
      >
        <v-btn
          color="primary"
          outlined
          @click="open"
        >
          <v-icon
            small
            class="mr-1"
          >
            fas fa-plus
          </v-icon>
          New Pick List
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="1"
        class="pb-0"
      >
        <inventory-class-select-element
          v-model="inventoryClassId"
          :is-state="true"
          :is-railings="false"
          :is-glass="false"
          :is-vwd-glass="false"
          :is-panels="false"
          :is-sid="false"
          :is-rail-part="false"
          :is-paint="false"
          :is-equipment="false"
          :is-patio-door="false"
          :is-euro-door="false"
          :is-medical-aid="false"
        />
      </v-col>
      <v-col
        cols="2"
        class="pb-0"
      >
        <v-select
          v-model="statusId"
          :items="statuses"
          label="Status"
          item-text="name"
          item-value="id"
          :loading="loadingStatuses"
        >
          <template #item="{ item }">
            <v-chip
              class="mt-1 mb-1"
              small
              text-color="white"
              style="cursor: pointer;"
              :color="item ? item.color : ''"
            >
              {{ item ? item.name : '' }}
            </v-chip>
          </template>
          <template #selection="{ item }">
            <v-chip
              class="mt-1 mb-1"
              small
              text-color="white"
              style="cursor: pointer;"
              :color="item ? item.color : 'white'"
            >
              {{ item ? item.name : '' }}
            </v-chip>
          </template>
        </v-select>
      </v-col>
      <v-col
        cols="3"
        class="pb-0"
      >
        <v-autocomplete
          v-model="projectId"
          :items="projects"
          item-value="id"
          item-text="name"
          label="Project"
          :loading="loadingProjects"
          clearable
        />
      </v-col>
      <v-col
        cols="3"
        class="pb-0"
      >
        <v-autocomplete
          v-model="departmentId"
          :items="departments"
          item-value="id"
          label="Department"
          item-text="name"
          :loading="loadingDepartments"
          clearable
        />
      </v-col>
      <v-col cols="2">
        <v-menu
          ref="menuFrom"
          v-model="dateMenuFrom"
          :return-value.sync="filterDateFrom"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template #activator="{ on, attrs }">
            <v-text-field
              v-model="filterDateFrom"
              label="Requested At"
              readonly
              v-bind="attrs"
              v-on="on"
              @change="$refs.menuFrom.save(filterDateFrom)"
            />
          </template>
          <v-date-picker
            v-model="filterDateFrom"
            no-title
            scrollable
          >
            <v-spacer />
            <v-btn
              text
              color="primary"
              @click="menuFrom = false"
            >
              Cancel
            </v-btn>
            <v-btn
              text
              color="primary"
              @click="filterDateFrom = null"
            >
              Clear
            </v-btn>
          </v-date-picker>
        </v-menu>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="pt-0">
        <v-card
          elevation="0"
          outlined
        >
          <v-data-table
            :headers="headers"
            :items="items"
            :footer-props="footer"
            :items-per-page="pagination.itemsPerPage"
            :search="search"
            :loading="loading"
            dense
            fixed-header
            :height="windowHeight"
            :server-items-length="total"
            @update:options="updateOptions"
          >
            <template
              v-for="h in headers"
              #[`header.${h.value}`]="{ header }"
            >
              <v-tooltip
                v-if="h.fullText"
                :key="h.value"
                top
              >
                <template #activator="{ on }">
                  <span v-on="on">{{ header.text }}</span>
                </template>
                <span>{{ header.fullText }}</span>
              </v-tooltip>
              <span
                v-else
                :key="h.value"
              >
                {{ h.text }}
              </span>
            </template>
            <template
              #[`item.inventory_class`]="{ item }"
            >
              <v-chip
                small
                :color="item && item.class ? item.class.color : 'grey'"
                text-color="white"
              >
                <text-highlight :queries="search">
                  {{ item && item.class ? item.class.name : '' }}
                </text-highlight>
              </v-chip>
            </template>
            <template #[`item.id`]="{ item }">
              <text-highlight
                :queries="search"
                style="font-weight: bold;"
              >
                {{ item.id }}
              </text-highlight>
            </template>
            <template #[`item.code`]="{ item }">
              <text-highlight
                :queries="search"
              >
                {{ item.code }}
              </text-highlight>
            </template>
            <template #[`item.project_name`]="{ item }">
              <text-highlight
                :queries="search"
                style="font-weight: bold;"
              >
                {{ item.project_name }}
              </text-highlight>
            </template>
            <template #[`item.job.code`]="{ item }">
              <span>
                <span style="font-weight: bold;"><text-highlight :queries="search">{{ item.job && item.job.code ? `${item.job.code}` : '' }}</text-highlight></span><text-highlight :queries="search"> - {{ item.job && item.job.name ? item.job.name : '' }}</text-highlight> <span style="color: #1976D2;"><text-highlight :queries="search">{{ item.job && item.job.reference ? `; ${item.job.reference}` : '' }}</text-highlight></span>
              </span>
            </template>
            <template #[`item.department_name`]="{ item }">
              <v-chip
                v-if="item.department"
                small
                text-color="white"
                style="cursor: pointer;"
                :color="item && item.department ? item.department.color : 'white'"
              >
                <text-highlight
                  :queries="search"
                >
                {{ item && item.department ? item.department.name : '' }}
                </text-highlight>
              </v-chip>
            </template>
            <template #[`item.truck_schedule_requests`]="{ item }">
              <v-tooltip
                v-if="item.truck_schedule_requests && item.truck_schedule_requests.length > 0"
                top
                color="black"
              >
                <template #activator="{ on }">
                  <span
                    style="color: #1976d2;"
                    v-on="on"
                  >DELIVERY REQUESTS</span>
                </template>
                <span
                  v-for="p in item.truck_schedule_requests"
                  :key="p.id"
                >
                  {{ p.id && p.id !== '-'? `${'DR# ' + p.id} ` : '' }}<br>
                </span>
              </v-tooltip>
              <span v-else>
                <span
                v-for="p in item.truck_schedule_requests"
                :key="p.id"
                >
                  <text-highlight :queries="search">{{ p.id && p.id !== '-' ? `${'DR# ' + p.id} ` : '' }}</text-highlight>
                </span>
              </span>
            </template>
            <template #[`item.total_quantity`]="{ item }">
              <text-highlight
                :queries="search"
              >
                {{ totalQuantity(item) }}
              </text-highlight>
            </template>
            <template #[`item.created_at`]="{ item }">
              <text-highlight
                :queries="search"
              >
                {{ item.created_at }}
              </text-highlight>
            </template>
            <template #[`item.user_full_name`]="{ item }">
              <text-highlight
                :queries="search"
              >
                {{ item.user_full_name }}
              </text-highlight>
            </template>
            <template #[`item.supplied_at`]="{ item }">
              <text-highlight
                :queries="search"
              >
                {{ item.supplied_at }}
              </text-highlight>
            </template>
            <template #[`item.supplier_full_name`]="{ item }">
              <text-highlight
                :queries="search"
              >
                {{ item.supplier_full_name }}
              </text-highlight>
            </template>
            <template #[`item.status`]="{ item }">
              <v-chip
                v-if="item.status"
                small
                text-color="white"
                style="cursor: pointer;"
                :color="item && item.status ? item.status.color : 'white'"
              >
                {{ item && item.status ? item.status.name : '' }}
              </v-chip>
            </template>
            <template #[`item.created_backorder.backorder_part_pick_list`]="{ item }">
              <text-highlight
                :queries="search"
              >
                {{ item.created_backorder && item.created_backorder.backorder_part_pick_list && item.created_backorder.backorder_part_pick_list.code ? item.created_backorder.backorder_part_pick_list.code : '-' }}
              </text-highlight>
            </template>
            <template #[`item.actions`]="{ item }">
              <v-btn
                v-if="item.status_id === statusIdShipped || hasBackorderPickList(item)"
                class="ml-1 mt-1 mb-1"
                color="primary"
                outlined
                small
                @click="openViewPick(item.id)"
              >
                VIEW
              </v-btn>
              <v-btn
                v-if="(roles.includes(userRoleIdAdmin) || roles.includes(userRoleIdAssociate) || roles.includes(userRoleIdPicker)) && item.status_id != statusIdShipped && item.status_id != statusIdCanceled && !hasBackorderPickList(item)"
                class="ml-1 mt-1 mb-1"
                color="primary"
                outlined
                small
                @click="openPick(item.id)"
              >
                PICK
              </v-btn>
              <v-btn
                v-if="(roles.includes(userRoleIdAdmin) || roles.includes(userRoleIdAssociate) || roles.includes(userRoleIdRequester)) && item.status_id != statusIdSupplied && item.status_id != statusIdShipped && item.status_id != statusIdCanceled && item.truck_schedule_request_id === null && !isBackorderPickList(item)"
                class="ml-1 mt-1 mb-1"
                color="success"
                outlined
                small
                @click="openEdit(item.id)"
              >
                EDIT
              </v-btn>
              <v-btn
                v-if="(roles.includes(userRoleIdAdmin) || roles.includes(userRoleIdDeliveriesManager) || belongsToCurrentUser(item)) && (item.status_id === statusIdSupplied || item.status_id === statusIdPartiallySupplied) && !isBackorderPickList(item)"
                class="ml-1 mt-1 mb-1"
                color="error"
                outlined
                small
                @click="cancel(item.id)"
              >
                CANCEL
              </v-btn>
              <v-btn
                v-if="(((roles.includes(userRoleIdAdmin) || roles.includes(userRoleIdDeliveriesManager) || belongsToCurrentUser(item)) && item.status_id === statusIdNew)) && !isBackorderPickList(item)"
                class="ml-1 mt-1 mb-1"
                color="error"
                outlined
                small
                @click="softDelete(item.id)"
              >
                DELETE
              </v-btn>
              <v-menu
                offset-y
              >
                <template #activator="{ on, attrs }">
                  <v-btn
                    class="ml-1 mt-1 mb-1"
                    elevation="0"
                    fab
                    outlined
                    x-small
                    v-bind="attrs"
                    tile
                    color="primary"
                    style="border-radius: 7px; width: 28px !important; height: 28px !important;"
                    v-on="on"
                  >
                    <v-icon>
                      mdi-dots-vertical
                    </v-icon>
                  </v-btn>
                </template>
                <v-list
                  class="pa-3"
                >
                  <v-list-item @click="runWebhook(item)">
                    <v-list-item-title
                      :style="`color: green; font-weight: 600;`"
                    >
                      <v-row align="center">
                        <v-col
                          cols="auto"
                          class="pr-0"
                          style="white-space: nowrap"
                        >
                          <v-icon
                            style="font-size: 16px"
                            color="green"
                          >
                            fas fa-file
                          </v-icon>
                        </v-col>
                        <v-col class="pt-4">
                          PDF
                        </v-col>
                      </v-row>
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="openAttachmentForm(item.id)">
                    <v-list-item-title :style="`color: orange; font-weight: 600;`">
                      <v-row align="center">
                        <v-col
                          cols="auto"
                          class="pr-0"
                          style="white-space: nowrap;"
                        >
                          <v-icon
                            style="font-size: 16px;"
                            color="orange"
                          >
                            fas fa-paperclip
                          </v-icon>
                        </v-col>
                        <v-col class="pt-4">
                          ATTACHMENTS
                        </v-col>
                      </v-row>
                    </v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    v-if="roles.includes(userRoleIdAdmin) || roles.includes(userRoleIdAssociate) || roles.includes(userRoleIdRequester)"
                    @click="toggle(item)"
                  >
                    <v-list-item-title :style="`color: purple; font-weight: 600;`">
                      <v-row align="center">
                        <v-col class="pt-4">
                          {{ item.is_archived === 0 ? 'ARCHIVE' : 'ACTIVATE' }}
                        </v-col>
                      </v-row>
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
    <part-pick-list-form
      ref="partForm"
      @success="success"
    />

    <attachment-form
      v-show="false"
      ref="attachmentForm"
      :title="'Pick List Attachments'"
      :show-images="true"
    />
    <confirm-form ref="confirmForm" />
  </v-container>
</template>

<script>
import PartPickListForm from '@/components/forms/partPickLists/PartPickListForm';
import { mapState } from 'vuex';
import * as FormatHelpers from '@/helpers/FormatHelpers';
import AttachmentForm from '@/components/elements/AttachmentForm';
import store from '@/store';
const JOB_LABEL = store.getters['businessRulesGetBoolean']('Jobs Rename to Release') ? 'Release' : 'Job';

export default {
  components: {
    PartPickListForm,
    AttachmentForm
  },
  data: () => ({
    items: [],
    projects: [],
    selectedLocationId: 0,
    inventoryClassId: null,
    projectId: null,
    departmentId: null,
    headers: [
      { text: 'Class', value: 'inventory_class', align: 'center', width: '4%', },
      { text: 'List#', value: 'id', width: '3%' },
      { text: 'Code', value: 'code', width: '3%' },
      { text: 'Project Name', value: 'project_name', width: '10%' },
      { text: `${JOB_LABEL} Ref`, value: 'job.code', width: '10%' },
      { text: 'Department', value: 'department_name', width: '8%', align: 'center'},
      { text: 'DR#', value: 'truck_schedule_requests', fullText: 'Delivery Request #', width: '3%' },
      { text: 'Records#', value: 'total_quantity', fullText: 'Item and Custom Item Count', width: '3%' },
      { text: 'Requested At', value: 'created_at', width: '5%' },
      { text: 'Requested By', value: 'user_full_name', width: '5%' },
      { text: 'Supplied At', value: 'supplied_at', width: '5%' },
      { text: 'Supplied By', value: 'supplier_full_name', width: '5%' },
      { text: 'Backorder PL', value: 'created_backorder.backorder_part_pick_list', width: '5%' },
      {
        text: 'Status', value: 'status', width: '8%', align: 'center',
      },
      {
        text: 'Actions', value: 'actions', align: 'end', width: '15%', sortable: false,
      },
    ],
    pagination: {
      itemsPerPage: 100,
      page: 1,
    },
    sort: {
      order_by_first: 'id',
      direction_sort: true,
    },
    footer: {
      'items-per-page-options': [10, 20, 50, 100, 500, 1000, -1],
    },
    loading: false,
    loadingProjects: false,
    loadingDepartments: false,
    loadingStatuses: false,
    departments: [],
    total: 0,
    windowHeight: 1000,
    topSpaceHeight: 280,
    roles: [],
    statuses: [],

    userRoleIdAdmin: 3,
    userRoleIdAssociate: 6,
    userRoleIdRequester: 15,
    userRoleIdPicker: 23,
    userRoleIdDeliveriesManager: 31,

    statusIdNew: 1,
    statusIdPartiallySupplied: 2,
    statusIdSupplied: 3,
    statusIdShipped: 4,
    statusIdCanceled: 5,

    truckScheduleStatusIdCanceled: 10,

    attachmentTypeIdPickList: 4,
    selectedTab: 0,
    statusId: 0,
    dateMenuFrom: false,
    filterDateFrom: null,
    pickState: true,
  }),
  computed: {
    ...mapState({
      search: (state) => state.search,
      user: (state) => state.user,
      partPickListState: (state) => state.partPickListState,
    }),
  },
  watch: {
    inventoryClassId() {
      this.get();
    },
    projectId(value) {
      this.storeState('project_id', value);
      this.get();
    },
    departmentId(value) {
      this.storeState('department_id', value);
      this.get();
    },
    statusId(value) {
      this.storeState('status_id', value);
      this.get();
    },
    pagination() {
      this.get();
    },
    search() {
      this.get();
    },
    selectedTab() {
      this.get();
    },
    filterDateFrom(value) {
      this.$refs.menuFrom.save(value);
      this.storeState('created_at', value);
      this.get();
    },
  },
  created() {
    if (this.partPickListState) {
      if (this.partPickListState.pagination) { this.pagination = this.partPickListState.pagination; }
      if (this.partPickListState.status_id) { this.statusId = this.partPickListState.status_id; }
      if (this.partPickListState.project_id) { this.projectId = this.partPickListState.project_id; }
      if (this.partPickListState.department_id) { this.departmentId = this.partPickListState.department_id; }
      if (this.partPickListState.created_at) { this.filterDateFrom = this.partPickListState.created_at; }
    }
    this.roles = this.user.roles.map((x) => x.id);
    window.scrollTo(0, document.body.scrollHeight);
    this.windowHeight = window.innerHeight - this.topSpaceHeight;
    this.init();
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize);
    });
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
  },
  methods: {
    init() {
      this.get();
      this.getProjects();
      this.getDepartments();
      this.getStatuses();
    },

    openAttachmentForm(id) {
      this.$refs.attachmentForm.open(id, this.attachmentTypeIdPickList);
    },

    storeState(property, value) {
      const state = this.partPickListState;
      state[property] = value;
      this.$store.commit('storePartPickListState', state);
    },

    async get() {
      this.loading = true;
      this.items = [];
      this.total = 0;
      const submitModel = {
        filters: {
          inventory_class_id: this.inventoryClassId,
          project_id: this.projectId,
          department_id: this.departmentId,
          is_archived: this.selectedTab,
          created_at: this.filterDateFrom,
          status_id: this.statusId,
        },
        includes: ['supplier_full_name', 'supplied_at'],
        pagination: this.pagination,
        search: this.search,
        sort: this.sort,
      };
      const res = await this.$api.partPickList.readData(submitModel);
      const cancelCode = 3001;
      if (res === cancelCode) { return; }
      if (!res || !res.data) {
        this.loading = false;
        this.items = [];
        return;
      }
      this.items = res.data;
      this.total = res.total;
      this.loading = false;
    },

    async getProjects() {
      this.loadingProjects = true;
      const submitModel = {
        filters: {
          is_all: 1,
        },
      };
      const res = await this.$api.project.read(submitModel);
      const cancelCode = 3001;
      if (res === cancelCode) { return; }
      if (!res || !res.data) {
        this.projects = [];
        return;
      }
      this.projects = res.data;
      this.loadingProjects = false;
    },

    async getDepartments() {
      this.loadingDepartments = true;
      this.departments = await this.$api.department.get();
      this.loadingDepartments = false;
    },

    async getStatuses() {
      this.loadingStatuses = true;
      const res = await this.$api.partPickListStatus.get();
      this.statuses.push({ name: 'ALL', id: 0, color: '#000000' });
      this.statuses.push(...res);
      this.loadingStatuses = false;
    },

    async softDelete(id) {
      const confirm = await this.$refs.confirmForm.open({
        title: 'Are you sure that you want to delete this record?',
      });
      if (!confirm) return;
      if (!id) return;

      const res = await this.$api.partPickList.delete(id);

      if (!res) {
        this.$bus.$emit('showError');
        return;
      }
      this.$bus.$emit('showSuccess');
      this.get();
    },

    async cancel(id) {
      //part pick list id
      const confirm = await this.$refs.confirmForm.open({
        title: 'Are you sure you want to return all items and mark it as CANCELLED?',
      });
      if (!confirm) return;
      if (!id) return;

      const res = await this.$api.partPickList.get(`cancel/${id}`);
      if (!res) {
        this.$bus.$emit('showError');
        return;
      }
      this.$bus.$emit('showSuccess');
      this.get();
    },

    open() {
      this.$refs.partForm.open();
    },

    openEdit(id) {
      this.$refs.partForm.open(id);
    },

    openPick(id) {
      this.$refs.partForm.open(id, this.pickState);
    },

    openViewPick(id) {
      const pickState = false;
      const isView = true;
      this.$refs.partForm.open(id, pickState, isView);
    },

    success() {
      this.$bus.$emit('showSuccess');
      this.get();
    },

    onResize() {
      this.windowHeight = window.innerHeight - this.topSpaceHeight;
    },

    updateOptions(newOptions) {
      // if (pagination.page !== this.pagination.page || pagination.itemsPerPage !== this.pagination.itemsPerPage) {
      //   this.pagination = pagination;
      //   this.storeState('pagination', pagination);
      // }
      this.pagination = newOptions;
      this.sort = {
        order_by_first: newOptions.sortBy[0],
        direction_sort: newOptions.sortDesc[0],
      }
    },

    async toggle(item) {
      const confirm = await this.$refs.confirmForm.open({
        title: `Are you sure you want to ${item.is_archived === 0 ? 'Archive' : 'Active'} this record?`,
      });
      if (!confirm) return;
      const isActive = item.is_archived === 1 ? 0 : 1;
      const res = await this.$api.partPickList.get(`toggle/${item.id}/${isActive}`);
      if (!res) return;
      this.$bus.$emit('showSuccess');
      this.get();
    },

    async runWebhook(item) {
      this.$bus.$emit('loading');
      const webhookModuleIdPickList = 59;
      const webhookData = {
        module_id: webhookModuleIdPickList,
        id: item.id,
      };

      const res = await this.$api.webhook.store(webhookData, 'run-download', { responseType: 'blob' });
      if (!res) {
        this.$bus.$emit('showError');
        this.$bus.$emit('loading');
        return;
      }

      const now = FormatHelpers.getFileTimestamp();
      const fileName = `${item.code}_${now}`;

      const file = new Blob([res], {
        type: 'application/pdf',
      });
      saveAs(file, fileName);
      this.$bus.$emit('loading');
    },

    hasBackorderPickList(item) {
      return item.created_backorder && item.created_backorder.backorder_part_pick_list && item.created_backorder.backorder_part_pick_list.id;
    },

    isBackorderPickList(item) {
      return item.backorder_id && item.backorder_id > 0;
    },

    totalQuantity(item) {
      const totalItems = parseInt(item.total_items ?? 0);
      const totalCustomItems = parseInt(item.total_custom_items ?? 0);

      return totalItems + totalCustomItems;
    },

    belongsToCurrentUser(item) {
      return item.created_by === this.user.id;
    }
  },
};
</script>
